import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';

const BG   = '#0A1628';
const S    = '#00F5A0';
const G    = '#8892A4';
const CARD = 'rgba(255,255,255,0.04)';
const BORD = 'rgba(255,255,255,0.1)';

const ConfirmBeneficiaryPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');

  const [state, setState]     = useState(token ? 'idle' : 'error');
  const [errorMsg, setErrorMsg] = useState('Ce lien est invalide, expiré ou déjà utilisé.');

  const handleAction = async (action) => {
    setState('loading');
    const { data, error } = await supabase.functions.invoke('confirm-beneficiary', {
      body: { token, action },
    });
    if (error || !data?.success) {
      setErrorMsg('Ce lien est invalide, expiré ou déjà utilisé.');
      setState('error');
    } else {
      setState('done');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: BG, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px' }}>
      <div style={{ maxWidth: 480, width: '100%' }}>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <span style={{ fontSize: 22, fontWeight: 700, color: S, letterSpacing: 1 }}>SafeHeir</span>
        </div>

        <div style={{ background: CARD, border: `1px solid ${BORD}`, borderRadius: 16, padding: '36px 32px' }}>

          {state === 'idle' && (
            <>
              <h1 style={{ fontSize: 20, fontWeight: 700, color: '#fff', margin: '0 0 16px', lineHeight: 1.3 }}>
                Confirmation de votre rôle de bénéficiaire
              </h1>
              <p style={{ fontSize: 14, color: G, lineHeight: 1.7, margin: '0 0 28px' }}>
                Vous avez été désigné(e) comme bénéficiaire numérique sur SafeHeir. Confirmez-vous ce rôle ?
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 28 }}>
                <button
                  onClick={() => handleAction('accept')}
                  style={{
                    padding: '14px 0', background: S, color: BG,
                    border: 'none', borderRadius: 10,
                    fontWeight: 700, fontSize: 15, cursor: 'pointer',
                  }}>
                  Accepter ce rôle
                </button>
                <button
                  onClick={() => handleAction('refuse')}
                  style={{
                    padding: '14px 0', background: 'transparent', color: G,
                    border: `1px solid ${BORD}`, borderRadius: 10,
                    fontWeight: 600, fontSize: 15, cursor: 'pointer',
                  }}>
                  Refuser ce rôle
                </button>
              </div>

              <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', lineHeight: 1.6, margin: 0 }}>
                SafeHeir traite l'adresse email que la personne vous ayant désigné(e) a transmise, dans le seul cadre
                de ce service. Droits d'accès, rectification, opposition, effacement — contact : contact@safeheir.fr.
              </p>
            </>
          )}

          {state === 'loading' && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{
                width: 36, height: 36, border: '3px solid rgba(255,255,255,0.1)',
                borderTopColor: S, borderRadius: '50%',
                animation: 'spin 0.8s linear infinite', margin: '0 auto 16px',
              }} />
              <p style={{ color: G, fontSize: 14, margin: 0 }}>Enregistrement en cours...</p>
            </div>
          )}

          {state === 'done' && (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 56, height: 56, background: 'rgba(0,245,160,0.1)',
                border: '1px solid rgba(0,245,160,0.25)', borderRadius: 14,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px',
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke={S} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: '#fff', margin: '0 0 10px' }}>Choix enregistré</h2>
              <p style={{ fontSize: 14, color: G, margin: 0, lineHeight: 1.6 }}>
                Merci, votre choix a été enregistré.
              </p>
            </div>
          )}

          {state === 'error' && (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 56, height: 56, background: 'rgba(239,68,68,0.08)',
                border: '1px solid rgba(239,68,68,0.2)', borderRadius: 14,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px',
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
              </div>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: '#fff', margin: '0 0 10px' }}>Lien invalide</h2>
              <p style={{ fontSize: 14, color: G, margin: 0, lineHeight: 1.6 }}>{errorMsg}</p>
            </div>
          )}

        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default ConfirmBeneficiaryPage;
